//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.MotionBuilder.js";
import "../Fields/Fields.ExternalFileProfileBuilder.js";
import "../Fields/Fields.ManualInputProfileBuilder.js";
import "../Fields/Fields.SketchProfileBuilder.js";
import "../Fields/Fields.TimeSeriesProfileBuilder.js";
import "../no/Fields.js";
let d=[[[1,"ExternalFileProfile",0,"Fields.ExternalFileProfileBuilder",0],[0,"FormatType",1,0],[0,"InputType",1,0],[1,"ManualInputProfile",0,"Fields.ManualInputProfileBuilder",0],[0,"Name",1,0],[0,"ShowExtrapolatedData",1,0],[1,"SketchProfile",0,"Fields.SketchProfileBuilder",0],[1,"TimeSeriesProfile",0,"Fields.TimeSeriesProfileBuilder",0]],[],[]];
SPLM.Motion.ProfileBuilder = class extends SPLM.Motion.MotionBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.ProfileBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.ProfileBuilder.TypeChoices = Object.freeze({
    "Sketch" : "Sketch", "ExternalFile" : "ExternalFile", "ManualInput" : "ManualInput"});

SPLM.Motion.ProfileBuilder.ExternalFileTypeChoices = Object.freeze({
    "TabularData" : "TabularData", "TimeSeries" : "TimeSeries"});

export default SPLM;